var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { button, secondary } from './citron';
var floatingButton = {
    bottom: 16,
    left: '50%',
    position: 'absolute',
    transform: 'translateX(-50%)',
};
var mobileLarge = {
    fontSize: '18px !important',
    height: 'unset !important',
    minWidth: '44px !important',
    minHeight: '44px !important',
    padding: "0 ".concat(24, "px"),
    display: 'inline-flex',
    alignItems: 'center',
};
var primaryButton = __assign(__assign({}, button), mobileLarge);
var secondaryButton = __assign(__assign({}, secondary), mobileLarge);
var defaultButton = __assign(__assign({}, secondary), mobileLarge);
var primaryFloatingButton = __assign(__assign({}, button), floatingButton);
var secondaryFloatingButton = __assign(__assign({}, secondary), floatingButton);
var defaultFloatingButton = __assign(__assign({}, secondary), floatingButton);
export { primaryButton, secondaryButton, defaultButton, primaryFloatingButton, secondaryFloatingButton, defaultFloatingButton, };
